import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Label } from "../../../../../../components/formInputs";
import { NumberTextField, TextField } from "../../../../../../components/formikFormInputs";
import { unmaskCurrency } from "../../../../../../utils/commonUtils";
import { useFormikContext } from "formik";
import { GWT_GEN2_STRATEGY } from "../../../../../../constants";


type IndividualIncomeProp = {
    CommonField: Function;
	conditionalRequired: boolean;
	currentlyEmployed?: string;
    financiallyDependent?: boolean;
    gwtV2FD?: boolean;
    isGiftorAgentInvite?: boolean;
	isGiftorPortal?: boolean;
	isGWTGenV2?: boolean;
}
type AllFieldsProps = {
    lastYearArr: any,
    CommonField: Function,
    values: any,
    errors: any,
    touched: any,
    handleChange: Function,
    handleBlur: Function,
    setFieldValue: Function,
    yearsArr: any,
    prefixText: string
}
export const AllFields = (props: AllFieldsProps) => {
    const {
        lastYearArr,
        CommonField,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        yearsArr,
        prefixText,
    } = props;


    return (<>
        {
            yearsArr.map((item, index) => {
                return (
                        <Grid container spacing={2} key={index}>
                            <Typography variant="caption" className="w100 mb15 floatLeft ml15">{item.label}</Typography>
                            {lastYearArr.map((field: any) => {
                                return (
                                        <Grid item xs={12} md={6} key={`indIncome${item.name}${field.name}`}>
                                            <div className="mb15">
                                                {
                                                    CommonField(
                                                            {
                                                                ...field,
                                                                name: `${prefixText}${item.name}${field.name}`,
                                                                id: `${prefixText}${item.name}${field.name}`,
                                                            },
                                                            {
                                                                values,
                                                                errors,
                                                                touched,
                                                                handleChange,
                                                                handleBlur,
                                                                setFieldValue,
                                                            },
                                                    )
                                                }
                                            </div>
                                        </Grid>
                                );
                            })}
                        </Grid>
                );
            })

        }
    </>);
};
export const allFieldsArr = (conditionalRequired, requiredConditional) => {
    return [
        {
            id: "AnnualSalary",
            name: "AnnualSalary",
            label: <Label label={"Annual Earned Income"} required={requiredConditional} />,
            isRequired: requiredConditional,
            component: NumberTextField,
            variant: "outlined",
            className: "dollerIcon",
            dollarSign: true,
        },
        {
            id: "OtherIncome",
            name: "OtherIncome",
            label: <Label label={"Annual Unearned Income"} required={requiredConditional} />,
            isRequired: requiredConditional,
            component: NumberTextField,
            variant: "outlined",
            className: "dollerIcon",
            dollarSign: true,
        },
    ];
};

const indOtherIncomeDetail = (values) => {
    return [{
        name: "indOtherIncomeDetail",
        label: <Label label={"Please indicate source of unearned income"} required={unmaskCurrency(values['indIncomeLastYearOtherIncome'] )> 0} />,
        isRequired: values['indIncomeLastYearOtherIncome'] > 0,
        component: TextField,
        variant: "outlined",
        className: "TextFieldWidth",
    }];
};
function IndividualIncome(props: IndividualIncomeProp) {
	const {
        CommonField,
		conditionalRequired,
		currentlyEmployed,
        financiallyDependent,
        gwtV2FD,
        isGiftorAgentInvite,
		isGiftorPortal,
		isGWTGenV2,
	} = props;
    const {values, errors, touched, handleChange, handleBlur, setFieldValue}: any = useFormikContext();
    const isGWTGen2 = (values && Number(values.strategyId) === GWT_GEN2_STRATEGY);
    const requiredConditional = (
            isGWTGenV2 ?
            (gwtV2FD ? (values["currentlyEmployed"] === "FULL_TIME" || values["currentlyEmployed"] === "PART_TIME" || values["currentlyEmployed"] === "SELF_EMPLOYED") : false) :
            !isGWTGen2
    ) || !isGiftorAgentInvite;
	const indYearsArr = [
		{ label: (<>{isGiftorPortal ? "Giftor" : "Individual"} Income <strong>last year</strong></>), name: "LastYear" },
	];
    const lastYearArr = allFieldsArr(conditionalRequired, requiredConditional);

	const individualNetWorth = [{
		id: "netWorth",
		name: "netWorth",
        label: <Label label={ isGiftorPortal ? "Giftor Net Worth" : "Individual Net Worth"} required={requiredConditional} />,
        isRequired: requiredConditional,
        component: NumberTextField,
        variant: "outlined",
        className: "TextFieldWidth dollerIcon",
        dollarSign: true,
    }];


	return <>
		<Grid item xs={12}>
			<div className="hLine" />
		</Grid>
		{ isGWTGenV2 && (financiallyDependent || currentlyEmployed === 'NO')  && <Typography variant="h6" className="colorRed">If you are a dependent or do not have an income, you do not have to fill out these fields.</Typography> }
		<Grid item xs={12}>
			<Typography variant="h6" component="strong" className="w100">{isGiftorPortal ? "Giftor Income" : "Individual Income"}</Typography>
		</Grid>
		<AllFields lastYearArr={lastYearArr} CommonField={CommonField} values={values}
				   errors={errors} handleChange={handleChange} handleBlur={handleBlur}
				   setFieldValue={setFieldValue} yearsArr={indYearsArr} touched={touched}
				   prefixText="indIncome"
		/>
            <Grid item xs={12} md={6} >
                {
                    indOtherIncomeDetail(values).map((field, index) => {
                        return (

                        <div key={index + field["name"]}>
                            {
                                CommonField(
                                    field,
                                    {
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        setFieldValue,
                                    },
                                )
                            }
                        </div>

                    );
                })
            }
        </Grid>
		<Grid item xs={12}>
            <Typography variant="h6" component="strong" className="mb0 w100 floatLeft">
                {isGiftorPortal ? "Giftor" : "Individual"} Net Worth
            </Typography>
		</Grid>
		{
			individualNetWorth.map((field, index) => {
				return (
					<Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
						<div>
							{
								CommonField(
									field,
									{
										values,
										errors,
										touched,
										handleChange,
										handleBlur,
										setFieldValue,
									},
								)
							}
						</div>
					</Grid>
				);
			})
		}
		<Grid item xs={12}>
			<div className="hLine" />
		</Grid>
	</>;
}

export default IndividualIncome;